import { colorStatus, FormNavigationTypes, i18n, UISizes, UITypes } from 'LibNeo'
import {
	BankGuarantee,
	BankGuaranteeFull,
	isStateNoTranslate,
	STATUS_UNPAID_VIEW,
	fieldsByFormBlock,
	STATUS_WITH_NAV,
	GuaranteeMediumType,
	ProductType,
	TYPE_ORGANIZATION,
	BgRequestNav,
	BgStatus,
} from 'Pages/ibro'
import { intersection } from 'lodash'
import { getDate } from 'Helpers'
import { LEAD_BEARER } from 'Pages/lead'

export const getOrgTypeByInn = (inn: string) => {
	if (inn.length === 12) return TYPE_ORGANIZATION.IP
	if (inn.length === 10) return TYPE_ORGANIZATION.OOO
	return ''
}

export const getIsView = (navItem: BgRequestNav, item: BankGuaranteeFull) => {
	if (
		navItem === BgRequestNav.TAX_REPORT &&
		intersection(item?.fields, fieldsByFormBlock[BgRequestNav.TAX_REPORT])?.length === 0
	)
		return false
	if (
		(navItem === BgRequestNav.DOCUMENTS || navItem === BgRequestNav.GUARANTEE_BLANK) &&
		!item.external_id
	)
		return false
	if (navItem === BgRequestNav.GUARANTEE_BLANK && item.status?.status_slug === BgStatus.RELEASED)
		return true
	if (navItem === BgRequestNav.GUARANTEE_PROJECT)
		return (
			item.status?.status_slug !== BgStatus.CL_CHECKED && item.status?.status_slug !== BgStatus.NOVA
		)

	return (
		navItem === BgRequestNav.ABOUT_BG ||
		(STATUS_WITH_NAV.includes(item.status?.status_slug) &&
			Boolean(intersection(item?.fields, fieldsByFormBlock[navItem])?.length))
	)
}

export const getStatusByType = (type: FormNavigationTypes) => {
	switch (type) {
		case FormNavigationTypes.Warning:
			return { icon: 'time', color: 'gold' as colorStatus }
		case FormNavigationTypes.Completed:
			return { icon: 'check-circle', color: 'emerald' as colorStatus }
		case FormNavigationTypes.Error:
			return { icon: 'alert-circle-outline', color: 'pink' as colorStatus }
		default:
			return undefined
	}
}

export const getDeliveryText = (type: GuaranteeMediumType, delivery: number) => {
	if (type === GuaranteeMediumType.ELECTRONIC) return 'Бесплатно'
	if (type === GuaranteeMediumType.PAPER) return `Доставка${'\u00A0'}${delivery}${'\u00A0'}₽`
}

export const getErrorStatusText = (isError: boolean) => {
	if (isError) return { text: 'Укажите параметры', color: 'gold' as colorStatus }
	return undefined
}
export const getErrorDocumentText = (isError: boolean) => {
	if (isError) return { text: 'Предоставьте документы', color: 'gold' as colorStatus }
	return undefined
}

export const isViewRepaid = (item: BankGuarantee) => {
	return (
		item.repaid ||
		(item.producttype === ProductType.PA && item.signdate) ||
		(item.producttype === ProductType.QD &&
			item.status &&
			STATUS_UNPAID_VIEW.includes(item.status?.status_slug))
	)
}

export const getDateText = (date: string) => {
	if (date === undefined) return i18n('common.placeholder_disable_data')
	return getDate(date)
}
export const getAddressText = <T extends { result?: string }>(address?: T) => {
	if (address === undefined) return i18n('common.placeholder_disable_text')
	return address?.result
}

export const getLockedText = (value?: string) => {
	if (value === undefined) return i18n('common.placeholder_disable_text')
	return value
}
export const getPassportDataText = (value: string | undefined, type: 'ser' | 'num' | 'code') => {
	if (value === undefined) return i18n(`common.placeholder_disable_passport_${type}`)
	return value
}

export const getIconConsent = (bearer?: LEAD_BEARER) => {
	switch (bearer) {
		case LEAD_BEARER.SMS:
			return {
				commonIconName: 'mobile',
				statusIcon: { name: 'checkmark-circle-2', type: UITypes.PRIMARY },
			}
		case LEAD_BEARER.PAPER:
			return {
				commonIconName: 'file-outline',
				statusIcon: { name: 'checkmark-circle-2', type: UITypes.PRIMARY },
			}
		case LEAD_BEARER.DIGITAL:
			return {
				commonIconName: 'globe',
				statusIcon: { name: 'checkmark-circle-2', type: UITypes.PRIMARY },
			}
		default:
			return { commonIconName: 'lock-outline', statusIcon: { name: 'error', type: UITypes.DANGER } }
	}
}

export const getIcon = (fieldError: boolean) => {
	if (fieldError) return { name: 'error', type: UITypes.DANGER }
	return {
		name: 'checkmark-circle-2-outline',
		type: UITypes.PRIMARY,
		size: UISizes.SMALL,
	}
}

export const getTranslateIsStateNo = (value: boolean) => {
	if (value === true) return isStateNoTranslate.true
	if (value === false) return isStateNoTranslate.false
	return ''
}
